
import permissions from "@/security/permissions";
import { Vue, Prop, Component, Ref } from "vue-property-decorator";
import CompanySelectorModal from "../../components/widgets/Modals/CompanySelectorModal.vue";

const typeTitles: Object = {
  consignee: "Consignee",
  shipper: "Shipper",
  orderby: "Order By"
};

@Component({
  components: {
    CompanySelectorModal
  }
})
export default class OrderParty extends Vue {
  @Prop({ default: "consignee" })
  public type: string;

  @Prop({ default: false })
  editable: boolean;

  @Prop({ default: {} })
  party: any;

  @Prop({ default: "" })
  rules: string | Object;

  @Prop({ default: 0 })
  deliveryForId?: number;

  @Prop({ default: null})
  addressVerificationStatusId: number;

  @Prop({ default: "" })
  orderType: string;

  @Ref() readonly orderbySelector!: any;
  @Ref() readonly shipperSelector!: any;
  @Ref() readonly consigneeSelector!: any;

  get shouldShowGeocode(): boolean {
    if(this.type === "orderby")
      return false;
    if(this.type === "consignee" && this.orderType !== "RET")
      return true;
    if(this.type === "shipper" && this.orderType === "RET")
      return true;
    return false;
  }

  get normalizedType(): string {
    return this.type.toLowerCase();
  }

  get isConsignee(): boolean {
    return this.normalizedType === "consignee";
  }

  get isShipper(): boolean {
    return this.normalizedType === "shipper";
  }

  get isOrderBy(): boolean {
    return this.normalizedType === "orderBy";
  }

  get title(): Array<any> {
    return typeTitles[this.normalizedType];
  }

  get modalRef(): string {
    return this.type + "Selector";
  }

  get modal() {
    return this.$refs[this.modalRef];
  }

  getCompanyId() {
    if(this.type === "consignee")
      return this.party.id;
    return "";
  }

  findParty(party) {
    if (party === "orderbySelector") {
      this.orderbySelector.show();
    } else if (party === "shipperSelector") {
      this.shipperSelector.show();
    } else if (party === "consigneeSelector") {
      this.consigneeSelector.show();
    }
  }

  companySelected(company) {
    this.$emit("party-updated", company, this.normalizedType);
  }

  canCreate(): boolean {
    return this.editable && this.hasAgentPermission(permissions.companies.create, this.deliveryForId);
  }
}
